module.exports = __webpack_public_path__ + "img/circleCheck.fab9f4a.png";